<template v-if="data">
    <div>
        <rkm-timeline>
            <rkm-timeline-item
                v-for="(item, i) in data.additionals.timeline"
                :key="i"
                :dateTime="item.dateTime"
                :title="item.title"
                :label="item.label"
                :disabled="item.disabled"
                :line-class="getTimeLineClass(item, i)"
            />
        </rkm-timeline>

        <rkm-form ref="RkmForm">
            <template v-if="data.form.atendimentoMedico.id">
                <rkm-row>
                    <rkm-col>
                        <box-paciente :data="data" disabled-acidente-trabalho />
                    </rkm-col>

                    <rkm-col v-if="data.form.historicoAtendimento.length > 0">
                        <box-historico-atendimento :data="data" />
                    </rkm-col>
                </rkm-row>

                <box-classificacao-risco :data="data" />

                <box-fator-risco :data="data" />

                <box-alergia :data="data" />

                <box-medicamento-uso-continuo :data="data" />

                <box-medicamento-uso :data="data" />

                <box-sinal-vital :data="data" />

                <box-escala-coma-glasgow
                    :data="data"
                    readonly
                />

                <rkm-row>
                    <rkm-col :cols="showBoxGestante ? 7 : 12">
                        <box-avaliacao-antropometrica :data="data" />
                    </rkm-col>

                    <rkm-col
                        v-if="showBoxGestante"
                        cols="5"
                        id="gestante"
                    >
                        <box-gestante :data="data" />
                    </rkm-col>
                </rkm-row>

                <box-atendimento
                    :data="data"
                    :visible="false"
                    class="mb-3"
                    readonly
                />

                <box-atendimento-enfermagem
                    :data="data"
                    :visible="!data.additionals.isAuxiliarTecnicoEnfermagem"
                />

                <box-anotacoes-enfermagem
                    :data="data"
                    funcionalidade="atendimento-enfermagem"
                />

                <box-observacao-geral :data="data" />

                <box-exame
                    :data="data"
                    show-profissional-executante
                />

                <box-servico-enfermagem :data="data" />

                <box-prescricao-interna :data="data" />

                <box-procedimento :data="data" />

                <box-protocolo :data="data" :disabled="true" v-if="data.model.dorToracica" />

                <box-setor-encaminhamento :data="data" :required="false" />
            </template>

            <template v-else>
                <box-paciente :data="data" />

                <box-classificacao-risco :data="data" />

                <box-fator-risco :data="data" />

                <box-sinal-vital :data="data" />

                <box-escala-coma-glasgow
                    :data="data"
                    readonly
                />

                <box-exame
                    class="mt-4"
                    show-profissional-executante
                    :data="data"
                    :add-enable="data.form.recepcao.isEncaminhamento"
                    :tipo-exame-id="enums.tipoExame.EXAME_LABORATORIAL"
                    :cboLotacaoAtual="false"
                />

                <box-servico-enfermagem :data="data" />

                <box-procedimento :data="data" />

                <box-protocolo :data="data" :disabled="true" v-if="data.model.dorToracica" />

                <box-setor-encaminhamento :data="data" :required="false" />
            </template>
        </rkm-form>

        <modal-impressao ref="ModalImpressao" />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </div>
</template>

<script>

// Components
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxMedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import BoxAnotacoesEnfermagem from '@/components/pronto-atendimento/components/anotacao-enfermagem/Index'
import BoxAtendimento from '@/components/pronto-atendimento/components/atendimento/Index'
import BoxAtendimentoEnfermagem from '@/components/pronto-atendimento/components/enfermagem/Index'
import BoxAvaliacaoAntropometrica from '@/components/pronto-atendimento/components/avaliacao-antropometrica/Index'
import BoxClassificacaoRisco from '@/components/pronto-atendimento/components/classificacao-risco/Index'
import BoxEscalaComaGlasgow from '@/components/pronto-atendimento/components/escala-coma-glasgow/Index'
import BoxExame from '@/components/pronto-atendimento/components/exame/Index'
import BoxFatorRisco from '@/components/pronto-atendimento/components/fator-risco/Index'
import BoxGestante from '@/components/pronto-atendimento/components/gestante/Index'
import BoxHistoricoAtendimento from '@/components/pronto-atendimento/components/historico-atendimento/Index'
import BoxMedicamentoUso from '@/components/pronto-atendimento/components/medicamento-uso/Index'
import BoxObservacaoGeral from '@/components/pronto-atendimento/components/observacao-geral/Index'
import BoxPaciente from '@/components/pronto-atendimento/components/paciente/Index'
import BoxPrescricaoInterna from '@/components/pronto-atendimento/components/prescricao-interna/Index'
import BoxProcedimento from '@/components/pronto-atendimento/components/procedimento/Index'
import BoxProtocolo from '@/components/pronto-atendimento/components/protocolo/Index'
import BoxServicoEnfermagem from '@/components/pronto-atendimento/components/servico-enfermagem/Index'
import BoxSetorEncaminhamento from '@/components/pronto-atendimento/components/setor-encaminhamento/Index'
import BoxSinalVital from '@/components/pronto-atendimento/components/sinal-vital/Index'
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import documentoTipo from '@/enums/cadastro/documentoTipo'
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoExame from '@/enums/parametrizacao/tipoExame'
import tipoAtendimento from '@/enums/pronto-atendimento/parametrizacao/tipoAtendimento'
import unidadeMedida from '@/enums/cadastro/unidadeMedida'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Vuex.
import { mapActions } from 'vuex'

// Others.
import moment from 'moment'

// Mixins.
import { error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica } from '@/mixins'

export default {
    computed: {
        showBoxGestante() {

            if (this.data.form.paciente.isDesconhecido) {

                return false
            }

            return this.data.form.paciente.sexo.id === this.enums.sexo.FEMININO
                && this.data.form.paciente.idade.anos >= 9
                && this.data.form.paciente.idade.anos <= 60
        },
    },
    created() {
        this.repositories.atendimentoEnfermagem = this.getConectaSusRepository('prontoAtendimento.enfermagem')
    },
    props: {
        data: { type: Object },
        plantaoId: { type: [String, Number], required: true },
    },
    data: () => ({
        repositories: {
            atendimentoEnfermagem: null
        },
        enums: {
            desfecho,
            documentoTipo,
            sexo,
            tipoAtendimento,
            unidadeMedida,
            tipoExame,
            setorTipo
        },
        model: {
            centroCustoParaId: null
        }
    }),
    components: {
        BoxAlergia,
        BoxMedicamentoUsoContinuo,
        BoxAnotacoesEnfermagem,
        BoxAtendimento,
        BoxAtendimentoEnfermagem,
        BoxAvaliacaoAntropometrica,
        BoxClassificacaoRisco,
        BoxEscalaComaGlasgow,
        BoxExame,
        BoxFatorRisco,
        BoxGestante,
        BoxHistoricoAtendimento,
        BoxMedicamentoUso,
        BoxObservacaoGeral,
        BoxPaciente,
        BoxPrescricaoInterna,
        BoxProcedimento,
        BoxProtocolo,
        BoxServicoEnfermagem,
        BoxSetorEncaminhamento,
        BoxSinalVital,
        ModalImpressao,
    },
    mixins: [error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getTimeLineClass(item, i) {

            return item.listClass
                || this.data.additionals.timeline[i - 1] && this.data.additionals.timeline[i - 1].listClass
        },
        handleDesfecho() {

            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.EVASAO) {

                const confirm = async () => {

                    this.data.model.cancelamentoDesfecho = true

                    this.resetDesfecho()

                    this.$nextTick().then(() => this.save())

                    return false
                }

                const desfecho = this.data.form.desfechos.find(desfecho => desfecho.id
                    == this.data.model.finalizacao.desfechoId).nome

                const msg = `Foi atribuído o desfecho <strong>${desfecho}</strong>. Se o atendimento for salvo sem ser
                    finalizado, a atribuição do desfecho será desfeita. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            } else if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.ALTA_MEDICA
                && !this.data.model.finalizacao.altaMedica.lotacaoId) {

                    const confirm = async () => {

                        this.data.model.cancelamentoDesfecho = true

                        this.resetDesfecho()

                        this.$nextTick().then(() => this.save())

                        return false
                    }

                    const desfecho = this.data.form.desfechos.find(desfecho => desfecho.id
                        == this.data.model.finalizacao.desfechoId).nome

                    const msg = `Foi atribuído o desfecho <strong>${desfecho}</strong> e o médico não foi informado.
                        Se o atendimento for salvo sem ser finalizado, a atribuição do desfecho será desfeita.
                        Deseja continuar?`

                    this.showConfirmation(msg, confirm)

                    return false

            } else {

                this.save()
            }
        },
        handleSave(){
            this.setLoading()

            let request = {
                plantaoId: this.plantaoId,
                atendimentoId: this.data.model.atendimentoId,
                classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                alergias: this.data.model.alergias.map(item => {
                    return {
                        alergiaId: item.alergia.id,
                        criticidadeId: item.alergia.criticidade.id,
                        reacoesObservacoes: item.alergia.reacoesObservacoes,
                    }
                }),
                medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => {
                    return {
                        medicamentoId: item.medicamento.id,
                    }
                }),
                medicamentosUso: this.data.model.medicamentosUso,
                sinaisVitais: this.data.model.sinaisVitais.map(item => {
                    return {
                        pa: item.pa || null,
                        paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                        glicemia: item.glicemia || null,
                        temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                        pulso: item.pulso || null,
                        respiracao: item.respiracao || null,
                        saturacao: item.saturacao || null,
                        intensidadeDor: item.intensidadeDor || null,
                        cintura: item.cintura || null,
                    }
                }),
                gestacao: {
                    gestante: this.data.model.gestacao.gestante,
                    dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('YYYY-MM-DD') : null,
                },
                fatoresRisco: this.data.model.fatoresRisco,
                fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                planejamento: this.data.model.planejamento,
                implementacao: this.data.model.implementacao,
                avaliacao: this.data.model.avaliacao,
                historico: this.data.model.historico,
                exameFisico: this.data.model.exameFisico,
                diagnostico: this.data.model.diagnostico,
                observacoes: this.data.model.observacoes,
                procedimentos: this.data.model.procedimentos.map(item => {
                    return {
                        procedimentoId: item.procedimento.id,
                        cidPrincipalId: item.cidPrincipal ? item.cidPrincipal.id : null,
                        quantidade: item.quantidade,
                    }
                }),
                centroCustoIdPara: this.data.model.centroCustoIdPara,
                servicosEnfermagem: this.data.model.servicosEnfermagem.map(item => {
                    return {
                        id: isNaN(item.id) ? null : item.id,
                        statusId: item.status.id,
                        procedimentoId: item.procedimento.id,
                        cidId: item.cid ? item.cid.id : null,
                        horarioRealizacao: item.horarioRealizacao,
                        observacoes: item.observacoes,
                    }
                }),
                anotacoes: this.data.model.anotacoes.map(item => {
                    return {
                        anotadoEm: moment(item.dataHoraAnotacao, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm'),
                        descricao: item.anotacao
                    }
                }),
            }

            request.prescricaoInternaAplicacoes = []

            this.data.model.prescricoesInterna.forEach(prescricao => {

                prescricao.medicamentos.forEach(medicamento => {

                    medicamento.aplicacoes.filter(a => !a.disabled).forEach(aplicacao => {

                        request.prescricaoInternaAplicacoes.push({
                            id: aplicacao.id,
                            statusId: aplicacao.status.id,
                            horarioAplicacao: aplicacao.horarioAplicacao,
                            localAplicacaoId: aplicacao.localAplicacaoId,
                        })
                    })
                })
            })

            if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                request.avaliacaoAntropometrica = {
                    massa: this.data.model.avaliacaoAntropometrica.massa,
                    massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                    alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                    altura: this.data.model.avaliacaoAntropometrica.altura,
                    alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                }
            }

            request.pedidosExames = this.data.model.pedidosExames
                .map(pedido => {

                    const pedidoData = {
                        isForm: pedido.isForm,
                        id: pedido.id,
                        urgente: pedido.urgente,
                        justificativa: pedido.justificativa || null,
                        exames: pedido.exames.map(exame => ({
                            id: exame.id,
                            exameId: exame.exame.id,
                            observacao: exame.observacao || null,
                            statusId: exame.status.id,
                            horarioRealizacao: exame.horarioRealizacao,
                            lotacaoExecutanteId: exame.lotacaoExecutanteId,
                        })),
                        files: pedido.files.filter(f => (f instanceof File)),
                    }

                    if (!Number.isInteger(pedido.id)) {

                        pedidoData.dataSolicitacao = pedido.dataSolicitacao
                        pedidoData.unidadeExternaEncaminhamentoId = pedido.unidadeExternaEncaminhamentoId
                        pedidoData.unidadeEncaminhamentoId = pedido.unidadeEncaminhamentoId
                        pedidoData.medicoSolicitanteEncaminhamento = pedido.medicoSolicitanteEncaminhamento
                    }

                    return pedidoData
                })

            request.cancelamentoDesfecho = this.data.model.cancelamentoDesfecho

            const formData = this.objectToFormData(this.camelObjectKeysToSnakeRecursive(request))

            this.repositories.atendimentoEnfermagem.store(formData)
                .then(({ data }) => {

                    const finish = () => {

                        this.$refs.ModalImpressao.open(
                            data.impressoes,
                            data.atendimentoId,
                            () => this.$emit('save')
                        )
                    }

                    if (data.assinar) {

                        this.afterSign = faaAssinada => {

                            return this.repositories.atendimentoEnfermagem.storeFaaAssinada(data.id, {
                                faa_assinada: faaAssinada
                            })
                        }

                        this.onSign = () => finish()
                        this.onSkipSign = () => finish()

                        this.askToSignAtendimento(
                            async () => this.signFaa(
                                data.atendimentoId,
                                [{ tipo: 'enfermagem', id: data.id }],
                                `faa-${data.faaId}-atendimento-enfermagem-${data.id}`
                            ),
                            async () => finish()
                        )
                    }
                    else {

                        this.showSaveNotification()

                        finish()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                const verificaHorario = this.data.model.pedidosExames.find(pedido => {
                    return pedido.exames.some(exame => {
                        return exame.status.id === 3 && !exame.horarioRealizacao;
                    });
                });

                if(verificaHorario){
                    this.showValidationNotification(
                        'Existe um ou mais procedimentos de Exame imagem/Laboratoriais que não possuem o horário preenchido.'
                    )

                    return false
                }

                if (response === true) {

                    let $getPedidosExames = '0'
                    let $getEnfermagem = '0'

                    const isCentroCustoParaExames = this.data.model.centroCustoIdPara !== null && this.data
                        .form.encaminhamentoSetores .find(es => es.id === this.data.model.centroCustoIdPara)
                            .tipo.id === this.enums.setorTipo.EXAMES

                    if(this.data.model.pedidosExames.length !== 0){

                        Object.keys(this.data.model.pedidosExames).forEach(e => {

                            Object.keys(this.data.model.pedidosExames[e].exames).forEach(f => {

                                Object.keys(this.data.model.pedidosExames[e].exames[f]).forEach(t => {

                                    if (t === 'status') {

                                        if(this.data.model.pedidosExames[e].exames[f][t].id === 1){
                                            $getPedidosExames = '1'
                                        }
                                    }
                                })
                            })
                        })
                    }

                    if(this.data.model.servicosEnfermagem.length !== 0){

                        Object.keys(this.data.model.servicosEnfermagem).forEach(a => {
                            Object.keys(this.data.model.servicosEnfermagem[a]).forEach(b => {

                                if (b === 'status') {

                                    if(this.data.model.servicosEnfermagem[a][b].id === 1){
                                    $getEnfermagem = '1'
                                    }
                                }
                            })
                        })
                    }

                    if ($getPedidosExames === '1' && $getEnfermagem === '1') {
                        this.showConfirmation(
                            'Há um ou mais EXAMES ou SERVIÇOS DE ENFERMAGEM solicitados. Se continuar com o'
                                + ' encaminhamento, as solicitações continuarão pendentes. Deseja continuar?',
                            async () => this.handleSave()
                        )
                    }

                    else if ($getPedidosExames === '1') {

                        this.showConfirmation(
                            'Há um ou mais exames solicitados. Se continuar com o encaminhamento, o exame continuará'
                                + ' pendente. Deseja continuar?',
                            async () => this.handleSave()
                        )
                    }

                    else if ($getEnfermagem === '1') {
                        this.showConfirmation(
                            'Há um ou mais serviços de enfermagem solicitados. Se continuar com o encaminhamento,'
                                + ' o serviço de enfermagem continuará pendente. Deseja continuar?',
                            async () => this.handleSave()
                        )
                    }

                    else if (!this.data.additionals.isEncaminhadoDaRecepcao && this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }

                    else if(isCentroCustoParaExames){

                        const hasNewPedidoExameImagem = this.data.model.pedidosExames.id && !!this.data.model
                            .pedidosExames.exames.find(e => e.tipoId === this.enums.tipoExame.IMAGEM)

                        const hasPreviousPedidoExameImagem = !!this.data.form.pedidosExames
                            .find(p => p.exames.find(e => e.tipoId === this.enums.tipoExame.IMAGEM))

                        const hasExameImagem = hasNewPedidoExameImagem || hasPreviousPedidoExameImagem

                        if (!hasExameImagem) {

                            this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: 'Não há exame de imagem solicitado. Solicite um ou mais para encaminhar a este setor.'
                            })

                            return
                        }
                    }

                    else {

                       this.handleSave()
                    }
                }
            })
        },
        resetDesfecho() {
            this.data.model.finalizacao = Object.assign(this.data.model.finalizacao, {
                desfechoId: null,
                evasao: {
                    motivo: null,
                }
            })
        },
    }
}
</script>